import { RESPONSEPAYMENTCARDCREATE, RESPONSEPAYMENTCARDSUCCESS, RESPONSEVERITYCARD } from "app/shared/services/services-model.type";
import {
  FETCH_PAYMENT_CARD_CREATE_REQUEST,
  FETCH_PAYMENT_CARD_CREATE_SUCCESS,
  FETCH_PAYMENT_CARD_CREATE_FAILURE,
  FETCH_PAYMENT_CARD_CONFIRM_REQUEST,
  FETCH_PAYMENT_CARD_CONFIRM_SUCCESS,
  FETCH_PAYMENT_CARD_CONFIRM_FAILURE,
  FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST,
  FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_SUCCESS,
  FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_FAILURE,
  SET_PAYMENT_CARD_STORE,
  SET_PAYMENT_CARD_RESET,
} from "./actions.type";
import {
  FetchPaymentCardCreateRequest,
  FetchPaymentCardCreateSuccess,
  FetchPaymentCardCreateFailure,
  FetchPaymentCardConfirmRequest,
  FetchPaymentCardConfirmSuccess,
  FetchPaymentCardConfirmFailure,
  FetchPaymentCardAuthorizationRequest,
  FetchPaymentCardAuthorizationSuccess,
  FetchPaymentCardAuthorizationFailure,
  DataPaymentCardCreate,
  SetPaymentCardStore,
  SetPaymentCardReset,
  PaymentCardState,
} from "./types";

export const fetchPaymentCardCreateRequest = (payload: DataPaymentCardCreate): FetchPaymentCardCreateRequest => ({
  type: FETCH_PAYMENT_CARD_CREATE_REQUEST,
  payload,
});

export const fetchPaymentCardCreateSuccess = (payload?: RESPONSEPAYMENTCARDCREATE): FetchPaymentCardCreateSuccess => ({
  type: FETCH_PAYMENT_CARD_CREATE_SUCCESS,
  payload,
});

export const fetchPaymentCardCreateFailure = (payload?: string): FetchPaymentCardCreateFailure => ({
  type: FETCH_PAYMENT_CARD_CREATE_FAILURE,
  payload,
});

export const fetchPaymentCardConfirmRequest = (): FetchPaymentCardConfirmRequest => ({
  type: FETCH_PAYMENT_CARD_CONFIRM_REQUEST,
});

export const fetchPaymentCardConfirmSuccess = (payload?: RESPONSEVERITYCARD): FetchPaymentCardConfirmSuccess => ({
  type: FETCH_PAYMENT_CARD_CONFIRM_SUCCESS,
  payload,
});

export const fetchPaymentCardConfirmFailure = (payload?: string): FetchPaymentCardConfirmFailure => ({
  type: FETCH_PAYMENT_CARD_CONFIRM_FAILURE,
  payload,
});

export const fetchPaymentCardAuthorizationRequest = (
  payload?: RESPONSEVERITYCARD,
  code?: string,
): FetchPaymentCardAuthorizationRequest => ({
  type: FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchPaymentCardAuthorizationSuccess = (payload?: RESPONSEPAYMENTCARDSUCCESS): FetchPaymentCardAuthorizationSuccess => ({
  type: FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchPaymentCardAuthorizationFailure = (payload?: boolean): FetchPaymentCardAuthorizationFailure => ({
  type: FETCH_PAYMENT_CARD_AUTHORIZATION_KEY_FAILURE,
  payload,
});

export const setPaymentCardStore = (payload: PaymentCardState): SetPaymentCardStore => ({
  type: SET_PAYMENT_CARD_STORE,
  payload,
});

export const setPaymentCardReset = (): SetPaymentCardReset => ({
  type: SET_PAYMENT_CARD_RESET,
});
